import React from 'react';

import { BaseModal } from '../../../../../../components/BaseModal';

interface DisableOrderAgentModalProps {
  isOpen: boolean;
  onClose: () => void;
  onConfirm: () => void;
  supplierName: string;
  isDisabling: boolean;
}

export const DisableOrderAgentModal: React.FC<DisableOrderAgentModalProps> = ({
  isOpen,
  onClose,
  onConfirm,
  supplierName,
  isDisabling,
}) => (
  <BaseModal
    isOpen={isOpen}
    onClose={onClose}
    size="md"
    title="Disable the Order Agent for this distributor?"
    isDismissable={!isDisabling}
    hideCloseButton
    footerContent={{
      onCancel: onClose,
      onConfirm,
      isLoading: isDisabling,
      isDisabled: isDisabling,
      isDestructive: true,
      confirmText: isDisabling ? 'DISABLING...' : 'DISABLE',
      cancelText: 'CANCEL',
    }}
  >
    <p className="text-default-500 text-sm">
      Choco AI will stop processing new orders sent to{' '}
      <span className="font-medium text-foreground">{supplierName}</span>.
      Orders already received are not affected, and the agent can be turned back
      on at any time.
    </p>
  </BaseModal>
);
